var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 8.66602H20.8673L13.6673 1.46602V7.33268C13.6673 8.13268 14.2007 8.66602 15.0007 8.66602ZM15.0007 11.3327C12.734 11.3327 11.0007 9.59935 11.0007 7.33268V0.666016H4.33398C2.06732 0.666016 0.333984 2.39935 0.333984 4.66602V23.3327C0.333984 25.5993 2.06732 27.3327 4.33398 27.3327H17.6673C19.934 27.3327 21.6673 25.5993 21.6673 23.3327V11.3327H15.0007ZM7.00065 8.66602H8.33398C9.13398 8.66602 9.66732 9.19935 9.66732 9.99935C9.66732 10.7993 9.13398 11.3327 8.33398 11.3327H7.00065C6.20065 11.3327 5.66732 10.7993 5.66732 9.99935C5.66732 9.19935 6.20065 8.66602 7.00065 8.66602ZM15.0007 21.9993H7.00065C6.20065 21.9993 5.66732 21.466 5.66732 20.666C5.66732 19.866 6.20065 19.3327 7.00065 19.3327H15.0007C15.8007 19.3327 16.334 19.866 16.334 20.666C16.334 21.466 15.8007 21.9993 15.0007 21.9993ZM15.0007 16.666H7.00065C6.20065 16.666 5.66732 16.1327 5.66732 15.3327C5.66732 14.5327 6.20065 13.9993 7.00065 13.9993H15.0007C15.8007 13.9993 16.334 14.5327 16.334 15.3327C16.334 16.1327 15.8007 16.666 15.0007 16.666Z",
    fill: "#3783FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkFile);
export default __webpack_public_path__ + "static/media/bulk_file.bed6cd971653cad43679874dd5d440fe.svg";
export { ForwardRef as ReactComponent };